<template>
  <div
    v-if="lpuSite"
    class="d-flex flex-wrap ga-2"
    data-qa="lpu_page_price_staff_links"
  >
    <CorePRG
      v-for="item in items"
      :key="item.label"
      :url="item.url"
      :button-attrs="{ class: 'adminka' }"
    >
      {{ item.label }}
    </CorePRG>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import CorePRG from 'src/core/CorePRG/CorePRG.vue'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

const props = defineProps<{
  lpuSite?: string
}>()

const items = computed(() => {
  const site = props.lpuSite

  if (!site) {
    return []
  }

  return [
    { label: tStatic('Прайс'), query: 'прайс' },
    { label: tStatic('Цена'), query: 'цена' },
    { label: tStatic('Стоимость'), query: 'стоимость' },
  ].map(item => ({
    label: item.label,
    url: `https://yandex.ru/search/?text=site:${site}+${item.query}`,
  }))
})
</script>
